var _mask, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMobileDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 58,
    width: 58,
    viewBox: "467.885 218.71 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32.042v32H0z",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.005 0A4.014 4.014 0 000 4v24c0 2.2 1.802 4 4.005 4h24.032c2.203 0 4.005-1.8 4.005-4V4c0-2.2-1.802-4-4.005-4z",
    fill: "#fff",
    mask: "url(#mask-1)",
    transform: "matrix(1.810124, 0, 0, 1.8125, 467.884552, 218.710297)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.792 15.157l12.865-7.479c.275-.16.289-.653-.02-.83-.308-.178-.893-.514-1.111-.643a1.004 1.004 0 00-.991.012c-.154.09-10.433 6.06-10.776 6.256-.412.236-.92.24-1.33 0L0 9.287v2.708c1.321.778 4.607 2.71 5.403 3.165.475.27.93.264 1.389-.003",
    transform: "matrix(1.810124, 0, 0, 1.8125, 467.884552, 218.710297)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.792 20.277l12.865-7.479c.275-.16.289-.653-.02-.83-.308-.178-.893-.514-1.111-.643a1.004 1.004 0 00-.991.012c-.154.09-10.433 6.06-10.776 6.256-.412.236-.92.24-1.33 0L0 14.407v2.708c1.321.778 4.607 2.71 5.403 3.165.475.27.93.264 1.389-.003",
    transform: "matrix(1.810124, 0, 0, 1.8125, 467.884552, 218.710297)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.792 25.717l12.865-7.479c.275-.16.289-.653-.02-.83-.308-.178-.893-.514-1.111-.643a1.004 1.004 0 00-.991.012c-.154.09-10.433 6.06-10.776 6.256-.412.236-.92.24-1.33 0L0 19.847v2.708c1.321.778 4.607 2.71 5.403 3.165.475.27.93.264 1.389-.003",
    transform: "matrix(1.810124, 0, 0, 1.8125, 467.884552, 218.710297)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobileDark);
export default __webpack_public_path__ + "static/media/logo-mobile-dark.ab41ba6da3c1890ff3a463ad8a37809c.svg";
export { ForwardRef as ReactComponent };